import React from 'react';
import './MainLayout.css';

import DashBoard from '../DashBoard/DashBoard';
import BasicPageAr from '../BasicPageAr/BasicPageAr';
import WorkingHoursAr from '../WorkingHoursAr/WorkingHoursAr';
import ReportPageAr from '../ReportPageAr/ReportPageAr';
import ProcedurePageAr from '../ProcedurePageAr/ProcedurePageAr';
import CompanyInfoAr from '../CompanyInfoAr/CompanyInfoAr';
import FormPageAr from '../FormPageAr/FormPageAr';
import PermissionsPageAr from '../PermissionsPageAr/PermissionsPageAr';
import ModalPageAr from '../ModalPageAr/ModalPageAr';
import MessagesSettings from '../messagesSettings/messagesSettings'
import MainHeaderAr from '../MainHeaderAr/MainHeaderAr';
import SideNavAr from '../SideNavAr/SideNavAr';
import $ from 'jquery';

import { Route, Redirect } from 'react-router-dom';
import { API, ip, adminIp } from './../../data/APIs';

import {
  Branches,
  // BranchesAr,
  Jobs,
  Projects,
  Nationalities,
  Tasks,
  WorkingTime,
  Employees,
  EmployeesGroups,
  VacationsTypes,
  OfficialHolidays,

  GetBranchTransactions,
  AddPermission,
  AddVacation,
  AddEditTransactions,

  EmployeesReport,
  WorkingTimeReport,
  DayStatusReport,
  DetailedAttendanceReport,
  TotalAttendanceReport,
  AbsenceReport,
  DelayReport,
  InCompleteTransReport,
  EarlyAttendanceReport,
  AttendanceSummaryReport,
  TotalAttendanceSummaryReport,
  OvertimeReport,
  WorkingTimeDetailsReport,
  BranchAttendanceReport,
  VacationsReport,
  PermissionsReport,
  DelayEarlyReport,
  TotalAbsenceReport,
  TotalDelayReport,

  Devices,
  UserPermission,
  GeneralSettings,
  SpecialWorkingDays
} from './../../data/PagePropsAr';
import Cookie from "js-cookie";
import DateCountdown from 'react-date-countdown-timer';
import Idle from 'react-idle'

// import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';

class MainLayoutAr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SideNavIsOpen: false,
      SideNavWasClosed: false,
      activePage: '',
      loadedPermissions: false,
      permissions: []
    }


    if (!this.state.loadedPermissions) {
      let end;
      let start = Date.now();
      console.log('Start: ' + start);
      fetch(ip + '/api/CustomGroupPermission/GetAllTapsWithPages', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookie.get('token')}`
        },
        body: JSON.stringify({
          "pageSize": 100,
          "pageNumber": 0,
          "searchCriteria": "",
          "selectedId": [
            0
          ]
        })
      })
        .then(response => response.json())
        .then((response) => {
          end = Date.now();
          console.log('End: ' + end);
          console.log('Time: ' + (end - start));
          if (response.success && response.data !== null) {
            //save permissions in a cookie
            Cookie.set('permissions', response.data, { SameSite: 'Lax' });
            this.setState({ permissions: response.data, loadedPermissions: true });
          } else {
            console.error(response);
          }
        })
        .catch(error => console.error('Unable to get Permissions.', error));
    }


  }

  componentDidMount() {
    // Handling navbar
    const mainLayout = document.querySelector('#mainLayout');
    if (document.getElementsByTagName('body')[0].offsetWidth > 991) {
      mainLayout.classList.add('show-side-nav');
      mainLayout.classList.remove('hide-side-nav');
      this.setState({ SideNavIsOpen: true });

    }
    if (document.getElementsByTagName('body')[0].offsetWidth < 991) {
      mainLayout.classList.remove('show-side-nav');
      mainLayout.classList.add('hide-side-nav');
      this.setState({ SideNavIsOpen: !(this.state.SideNavIsOpen) });
    }
    document.getElementsByTagName('body')[0].onresize = () => {
      if (document.getElementsByTagName('body')[0].offsetWidth > 991 && !(this.state.SideNavWasClosed)) {

      }
      if (document.getElementsByTagName('body')[0].offsetWidth < 991 && !(this.state.SideNavWasClosed)) {

      }
    };
    // if permissions not loaded yet load permissions


  }

  render() {

    // Styling:
    // ========
    const hideSideNav = () => {
      const sideNav = document.querySelector('#sideNav');
      sideNav.classList.remove('show-side-nav');
      sideNav.classList.add('hide-side-nav');
      const mainLayout = document.querySelector('#mainLayout');
      mainLayout.classList.toggle('show-side-nav');
      mainLayout.classList.toggle('hide-side-nav');
      const sideAR = document.querySelector('.side-ar');
      sideAR.classList.toggle('show-side-nav');
      sideAR.classList.toggle('hide-side-nav');
      this.setState({ SideNavIsOpen: false });
      this.setState({ SideNavWasClosed: true });
    }
    if (window.innerHeight <= 500) {
      $("section.MainLayout--").css('min-height', window.innerHeight - 50)
    }
    if (window.innerHeight >= 500) {
      $("section.MainLayout--").css('min-height', document.innerHeight - 50)
    }
    const toggleSideNav = () => {

      const sideNav = document.querySelector('#sideNav');
      sideNav.classList.toggle('show-side-nav');
      sideNav.classList.toggle('hide-side-nav');
      const mainLayout = document.querySelector('#mainLayout');
      mainLayout.classList.toggle('show-side-nav');
      mainLayout.classList.toggle('hide-side-nav');

      // const timerAlert = document.querySelector('#timer-alert');
      // timerAlert.classList.toggle('show-side-nav');
      // timerAlert.classList.toggle('hide-side-nav');

      const sideAR = document.querySelector('.side-ar');
      sideAR.classList.toggle('show-side-nav');
      sideAR.classList.toggle('hide-side-nav');
      // const clock = document.querySelector('#clock');
      // clock.classList.toggle('hide-side-nav');
      const SideToggleButton = document.querySelector('#SideToggleButton');
      SideToggleButton.classList.toggle('hide-side-nav');
      if (this.state.SideNavIsOpen) {
        this.setState({ SideNavIsOpen: false });
        this.setState({ SideNavWasClosed: true });
      } else {
        this.setState({ SideNavIsOpen: true });
      }

    }
    const activatePage = (page) => {
      this.setState({ activePage: page })
    }
    // ========

    let mainLayout = this;

    return (
      <div
        dir="rtl"
        style={{ fontWeight: '500', fontSize: '14px' }}
        className='mainlayoutAr'
      >

        {/* Website Master Page Header */}
        <MainHeaderAr />

        {/* <div className="time-alert row box-blue show-side-nav alert alert-warning" id=
          "timer-alert">
   
          <div className="col-sm-6 d-flex">
          <div className=" mx-1">
          باقي من الوقت 
          </div>
          <div className=" mx-1"  dir="ltr">
            <strong>
            <DateCountdown dateTo='January 16, 2021 00:00:00 GMT+02:00' callback={() => alert('Hello')} />
              </strong>

          </div>
          <div className=" mx-1">
          وتنتهي باقتك
        </div>
          </div>
          <div className="col-sm-4 d-flex  align-items-center  justify-content-end">
            <a className="btn add square gradient mx-2 alert-btn"
            // href={adminIp + "/renew?companyName=" + this.state.data.uniqueName + "&status=1"}
            > تجديد الباقة </a>
            <a className="btn gray move-up mx-2" onClick={(e)=>$("#timer-alert").addClass("d-none")}
            >  لاحقاً </a>
          </div>
        </div>
        */}
        <SideNavAr
          activatePage={activatePage}
          toggleSideNav={toggleSideNav}
          hideSideNav={hideSideNav}
          activePage={this.state.activePage}
          permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions : null}
        />
        {/* Master Page Body (Content Holder) */}
        <section id='mainLayout' className='MainLayout-- ar '>
          <Route path='/Ar/TAW/Main/Dashboard' render={() => <DashBoard lang='ar'></DashBoard>} />
          <Route path='/Ar/TAW/Main/Branches'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle='الفروع'
                    title="الفروع"
                    path={[{ title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }]}
                    searchFields={[
                      // { label: 'الرقم', type: 'number', backName: 'id' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' }
                    ]}
                    columns={[
                      // {
                      //   name: 'الرقم',
                      //   backName: 'id'
                      // },
                      {
                        name: 'الإسم',
                        backName: 'nameAr',
                        link: { to: '/Ar/TAW/Main/Managements/', routeValues: ['id', 'nameAr'] }
                      },
                      {
                        name: 'المدير',
                        backName: 'managerName'
                      },
                      {
                        name: 'الموظفون',
                        backName: 'employeesCount'
                      },
                      {
                        name: 'الإدارات',
                        backName: 'administrationsCount'
                      }
                    ]}
                    createEntityProps={[
                      { label: 'الإسم العربي', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'nameAr' },
                      { label: 'الإسم الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'nameEn' },
                      {
                        label: 'المدير', type: 'select', validation: '', style: 'col-lg-6', backName: 'managerId', url: API.Employees.read,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    updateEntityProps={[
                      { label: 'الإسم العربي', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'nameAr' },
                      { label: 'الإسم الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'nameEn' },
                      {
                        label: 'المدير', type: 'select', validation: '', style: 'col-lg-6', backName: 'managerId', url: API.Employees.read,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    deleteMessage="كل الإدارات و الأقسام المتعلقة بهذا الفرع سيتم حذفها, هل تريد الاستمرار؟"
                    create={Branches.create}
                    read={Branches.read}
                    update={Branches.update}
                    delete={Branches.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 1) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Managements/:branchId/:branchName'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={`الإدارات في (${match.params.branchName})`}
                    title={match.params.branchName}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الفروع', path: '/Ar/TAW/Main/Branches' }
                    ]}
                    params={match.params}
                    searchFields={[
                      // { label: 'الرقم', type: 'text', backName: 'id' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' }
                    ]}
                    columns={[
                      // { name: 'الرقم', backName: 'id' },
                      { name: 'الإسم', backName: 'nameAr', link: { to: '/Ar/TAW/Main/Departments/', routeValues: ['branchId', 'branchName', 'id', 'nameAr'] } },
                      { name: 'المدير', backName: 'managerName' },
                      { name: 'الموظفون', backName: 'employeesCount' },
                      { name: 'الأقسام', backName: 'departmentCount' }
                    ]}
                    createEntityProps={[
                      { label: 'الإسم العربي', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'nameAr' },
                      { label: 'الإسم الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'nameEn' },
                      {
                        label: 'المدير', type: 'select', validation: '', style: 'col-lg-6', backName: 'managerId', url: API.Employees.read,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    updateEntityProps={[
                      { label: 'الإسم العربي', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'nameAr' },
                      { label: 'الإسم الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'nameEn' },
                      {
                        label: 'المدير', type: 'select', validation: '', style: 'col-lg-6', backName: 'managerId', url: API.Employees.read,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    create={{
                      url: API.Directorates.create,
                      body: {
                        nameAr: '',
                        nameEn: '',
                        branchId: Number.parseInt(match.params.branchId),
                        managerId: ''
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: API.Directorates.read,
                      body: {
                        pageSize: 10,
                        pageNumber: 0,
                        search: {
                          "id": 0,
                          "nameEn": "",
                          "nameAr": "",
                          "branchId": Number.parseInt(match.params.branchId)
                        }

                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: API.Directorates.update,
                      body: {
                        id: '',
                        nameAr: '',
                        nameEn: '',
                        managerId: '',
                        branchId: Number.parseInt(match.params.branchId)
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: API.Directorates.delete,
                      query: {
                        branchId: ''
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 1) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Departments/:branchId/:branchName/:managementId/:managementName'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={`الأقسام في (${match.params.managementName})`}
                    title={match.params.managementName}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الفروع', path: '/Ar/TAW/Main/Branches' },
                      { title: match.params.branchName, path: '/Ar/TAW/Main/Managements/' + match.params.branchId + '/' + match.params.branchName }
                    ]}
                    params={match.params}
                    searchFields={[
                      // { label: 'الرقم', type: 'text', backName: 'id' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' }
                    ]}
                    columns={[
                      // { name: 'الرقم', backName: 'id' },
                      { name: 'الإسم', backName: 'nameAr' },
                      { name: 'المدير', backName: 'managerName' },
                      { name: 'الموظفون', backName: 'employeesCount' }
                    ]}
                    createEntityProps={[
                      { label: 'الإسم العربي', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'nameAr' },
                      { label: 'الإسم الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'nameEn' },
                      {
                        label: 'المدير', type: 'select', validation: '', style: 'col-lg-6', backName: 'managerId', url: API.Employees.read,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    updateEntityProps={[
                      { label: 'الإسم العربي', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'nameAr' },
                      { label: 'الإسم الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'nameEn' },
                      {
                        label: 'المدير', type: 'select', validation: '', style: 'col-lg-6', backName: 'managerId', url: API.Employees.read,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    create={{
                      url: API.Departments.create,
                      body: {
                        nameAr: '',
                        nameEn: '',
                        administrationId: Number.parseInt(match.params.managementId),
                        managerId: ''
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: API.Departments.read,
                      body: {
                        pageSize: 10,
                        pageNumber: 0,
                        search: {
                          administrationId: Number.parseInt(match.params.managementId)
                        }
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: API.Departments.update,
                      body: {
                        id: '',
                        nameAr: '',
                        nameEn: '',
                        managerId: '',
                        administrationId: Number.parseInt(match.params.managementId)
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: API.Departments.delete,
                      query: {
                        branchId: ''
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 1) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Jobs'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={Jobs.mainTitle}
                    title={Jobs.title}
                    path={Jobs.path}
                    searchFields={Jobs.searchFields}
                    columns={Jobs.columns}
                    createEntityProps={Jobs.createEntityProps}
                    updateEntityProps={Jobs.updateEntityProps}
                    deleteMessage={Jobs.deleteMessage}
                    create={Jobs.create}
                    read={Jobs.read}
                    update={Jobs.update}
                    delete={Jobs.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 2) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Projects'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={Projects.mainTitle}
                    title={Projects.title}
                    path={Projects.path}
                    searchFields={Projects.searchFields}
                    columns={Projects.columns}
                    createEntityProps={Projects.createEntityProps}
                    updateEntityProps={Projects.updateEntityProps}
                    deleteMessage={Projects.deleteMessage}
                    create={Projects.create}
                    read={Projects.read}
                    update={Projects.update}
                    delete={Projects.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 3) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Nationalities'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={Nationalities.mainTitle}
                    title={Nationalities.title}
                    path={Nationalities.path}
                    searchFields={Nationalities.searchFields}
                    columns={Nationalities.columns}
                    createEntityProps={Nationalities.createEntityProps}
                    updateEntityProps={Nationalities.updateEntityProps}
                    deleteMessage={Nationalities.deleteMessage}
                    create={Nationalities.create}
                    read={Nationalities.read}
                    update={Nationalities.update}
                    delete={Nationalities.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 4) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Tasks'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={Tasks.mainTitle}
                    title={Tasks.title}
                    path={Tasks.path}
                    searchFields={Tasks.searchFields}
                    columns={Tasks.columns}
                    createEntityProps={Tasks.createEntityProps}
                    updateEntityProps={Tasks.updateEntityProps}
                    deleteMessage={Tasks.deleteMessage}
                    create={Tasks.create}
                    read={Tasks.read}
                    update={Tasks.update}
                    delete={Tasks.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 5) : null}

                  />
                )
              }
            }
          />
          <Route exact={true} path='/Ar/TAW/Main/WorkingTime'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={WorkingTime.mainTitle}
                    title={WorkingTime.title}
                    path={WorkingTime.path}
                    searchFields={WorkingTime.searchFields}
                    columns={WorkingTime.columns}
                    createEntityProps={WorkingTime.createEntityProps}
                    updateEntityProps={WorkingTime.updateEntityProps}
                    deleteMessage={WorkingTime.deleteMessage}
                    create={WorkingTime.create}
                    read={WorkingTime.read}
                    update={WorkingTime.update}
                    delete={WorkingTime.delete}
                    checkboxgreen={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 6) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/WorkingTime/WorkingHours/:id/:open/:name'
            render={
              function ({ match }) {
                return (
                  <WorkingHoursAr
                    mainTitle={`ساعات عمل (${match.params.name})`}
                    title={match.params.name}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'أوقات العمل', path: '/Ar/TAW/Main/WorkingTime' }
                    ]}
                    read={{
                      url: ip + '/api/Shift/GetShiftDetails',
                      path: {
                        shiftId: Number.parseInt(match.params.id),
                        shiftType: 1
                      },
                      verb: 'GET'
                    }}
                    update={match.params.open === 'true' ?
                      {
                        url: ip + '/api/Shift/UpdateOpenShiftDay',
                        body: {
                          "id": 0,
                          "dayId": 0,
                          "shiftId": Number.parseInt(match.params.id),
                          "totalDayHours": 0,
                          "shiftType": 1,
                          "isVacation": true
                        },
                        verb: 'POST'
                      }
                      :
                      {
                        url: ip + '/api/Shift/UpdateShiftDay',
                        body: {
                          "id": 0,
                          "dayId": 0,
                          "shiftId": Number.parseInt(match.params.id),
                          "shiftType": 1,
                          "isVacation": true,
                          "periodShiftParameterList": [
                            {
                              "seq": 1,
                              "inTime": "",
                              "outTime": "",
                              "startIn": "",
                              "endIn": "",
                              "startOut": "",
                              "endOut": "",
                              "availableEarlyTime": "",
                              "availableLateTime": ""
                            },
                            {
                              "seq": 2,
                              "inTime": "",
                              "outTime": "",
                              "startIn": "",
                              "endIn": "",
                              "startOut": "",
                              "endOut": "",
                              "availableEarlyTime": "",
                              "availableLateTime": ""
                            },
                            {
                              "seq": 3,
                              "inTime": "",
                              "outTime": "",
                              "startIn": "",
                              "endIn": "",
                              "startOut": "",
                              "endOut": "",
                              "availableEarlyTime": "",
                              "availableLateTime": ""
                            },
                            {
                              "seq": 4,
                              "inTime": "",
                              "outTime": "",
                              "startIn": "",
                              "endIn": "",
                              "startOut": "",
                              "endOut": "",
                              "availableEarlyTime": "",
                              "availableLateTime": ""
                            }
                          ]
                        },
                        verb: 'POST'
                      }}
                    open={match.params.open}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 6) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/Employees'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={Employees.mainTitle}
                    title={Employees.title}
                    path={Employees.path}
                    searchFields={Employees.searchFields}
                    columns={Employees.columns}
                    createEntityProps={Employees.createEntityProps}
                    updateEntityProps={Employees.updateEntityProps}
                    deleteMessage={Employees.deleteMessage}
                    create={Employees.create}
                    read={Employees.read}
                    update={Employees.update}
                    delete={Employees.delete}
                    routOut={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 7) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AddEmployee'
            render={
              function () {
                return (
                  <ModalPageAr
                    title={`إضافة موظف`}
                    path={[{ title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                    { title: 'الموظفون', path: '/Ar/TAW/Main/Employees' },
                    { title: 'إضافة موظف', path: '/Ar/TAW/Main/AddEmployee' }]}
                    EntityProps={Employees.createEntityProps}
                    read={undefined}
                    action={Employees.create}
                    routOut={true}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AddUnsignEmployee/:code'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`إضافة موظف`}
                    path={[{ title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                    { title: ' الموظفون غير المسجلين ', path: '/Ar/TAW/Main/UnregisteredEmployees' },
                    { title: 'إضافة موظف', path: '/Ar/TAW/Main/AddUnsignEmployee' }]}
                    EntityProps={Employees.createEntityProps}
                    //  read={}
                    action={{
                      url: ip + '/api/Employee/AddEmployee',
                      body: {
                        "employeeCode": match.params.code,
                        "nameEn": '',
                        "nameAr": '',
                        "phoneNumber": '',
                        "placeStay": '',
                        "nationalityNumber": '',
                        "email": '',
                        "branchId": '',
                        "departmentId": '',
                        "adminstratId": '',
                        "jobId": '',
                        "groupId": '',
                        "projectId": '',
                        "nationalitiesId": '',
                        "workTasksId": '',
                        "shiftId": '',
                        "extraTimeAfterWorking": false,
                        "extraTimeBeforeWorking": false,
                        "addWorkingHoursOnHoliday": false,
                        "logOutWithoutFingerprint": false,
                        "provideDelayDiscountingOvertime": false,
                        "active": true
                      },
                      verb: 'POST'
                    }}
                    routUnregistered={true}

                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/EditEmployee/:id'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`تعديل موظف`}
                    path={[{ title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                    { title: 'الموظفون', path: '/Ar/TAW/Main/Employees' },
                    { title: 'تعديل  موظف', path: '/Ar/TAW/Main/EditEmployee/:id' }]}
                    EntityProps={Employees.updateEntityProps}
                    read={{
                      url: ip + '/api/Employee/GetEmployees',
                      path: {
                        employeeId: match.params.id
                      },
                      verb: 'GET'
                    }}
                    action={Employees.update}
                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/emailEdites'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`اضافة معلومات البريد`}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: 'تعديل البريد ', path: '/Ar/TAW/Main/emailEdites' }
                    ]}
                    pageName='emailEdites'
                    read={{
                      url: ip + '/api/GetEmailRequest',
                      verb: 'GET'
                    }}
                    type="generalSettings"
                    action={{
                      url: ip + '/api/UpdateRequest',
                      body: {
                        "id": '',
                        "email": "",
                        "password": ""
                      },
                      verb: 'POST'
                    }}
                    EntityProps={[
                      { label: 'البريد الإلكتروني', type: 'email', validation: '', style: 'col-lg-6', backName: 'email' },
                      { label: 'الرقم السري', type: 'text', validation: '', style: 'col-lg-6', backName: 'password' },
                      { label: 'اسم المضيف', type: 'text', validation: '', style: 'col-lg-6', backName: 'hostName' },
                      { label: 'رقم البورت ', type: 'text', validation: '', style: 'col-lg-6', backName: 'portNumber' }
                    ]}
                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/autoTransaction'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={`اعدادات السحب التلقائي  `}
                    title={`اعدادات السحب التلقائي  `}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: ' اعدادات السحب التلقائي ', path: '/Ar/TAW/Main/autoTransaction' }
                    ]}
                    // searchFields={[]}
                    searchFields={[{
                      label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown,
                      body: {
                        "pageSize": 100,
                        "pageNumber": 0,
                        "searchCriteria": "",
                        "selectedId": [
                          0
                        ]
                      },
                      item: { value: 'id', label: 'nameAr' }
                    }]}
                    columns={[
                      { name: 'اسم الفرع', backName: 'branchName' },
                      { name: 'الوقت', backName: 'timeTransfer' },
                    ]}
                    createEntityProps={[
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown, style: 'col-lg-6',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      { label: 'الوقت', type: 'time', validation: 'Required', style: 'col-lg-6', backName: 'timeTransfer' },
                    ]}
                    updateEntityProps={[
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown, style: 'col-lg-6',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      { label: 'الوقت', type: 'time', validation: 'Required', style: 'col-lg-6', backName: 'timeTransfer' },
                    ]}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    create={{
                      url: ip + '/api/AddReadAndMoveSetting',
                      body: {
                        "branchId": 0,
                        "timeTransfer": ""
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + '/api/GetAllReadAndMoveSetting',
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "search": {

                        }
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: ip + '/api/UpdateReadAndMoveSettingById',
                      body: {
                        "id": 0,
                        "branchId": 0,
                        "timeTransfer": ""
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: ip + '/api/DeleteReadAndMoveSetting',
                      query: {
                        ReadAndMoveId: ''
                      },
                      verb: 'POST'
                    }}
                    allPermissions={true}

                  />

                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/planEdites'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`اعدادات الباقة والاشتراك  `}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: ' اعدادات الباقة و الاشتراك', path: '/Ar/TAW/Main/planEdites' }
                    ]}
                    pageName='planEdites'
                    read={{
                      url: ip + '/api/GetCompanyBundleData',
                      verb: 'GET'
                    }}
                    type="generalSettings"
                    action={'renew'}
                    EntityProps={[

                      { label: 'اسم الباقة', type: 'info', validation: '', style: 'col-lg-6', backName: 'bundleName', disabled: true },
                      { label: 'مدة الاشتراك', type: 'info', validation: '', style: 'col-lg-6', backName: 'subscriptionDays', disabled: true },
                      { label: 'بداية الأشتراك', type: 'info', validation: '', style: 'col-lg-6', backName: 'startDate', disabled: true },
                      { label: 'نهاية الاشتراك', type: 'info', validation: '', style: 'col-lg-6', backName: 'endDate', disabled: true },

                    ]}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/smsEdites'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`اضافة معلومات الرسائل`}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: 'تعديل الرسائل ', path: '/Ar/TAW/Main/smsEdites' }
                    ]}
                    pageName='smsEdites'
                    read={{
                      url: ip + '/api/GetSMSRequest',
                      verb: 'GET'
                    }}
                    type="generalSettings"
                    action={{
                      url: ip + '/api/UpdateSMSRequest',
                      body: {
                        "id": '',
                        "userName": "",
                        "password": "",
                        "senderName": "",
                        "smsCompanyId": ""
                      },
                      verb: 'POST'
                    }}
                    EntityProps={[
                      {
                        label: 'اسم الشركة', type: 'select', validation: 'Required', style: 'col-lg-6', backName: 'smsCompanyId', url: ip + '/api/GetAllEmailRequestsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      { label: 'اسم المستخدم', type: 'text', validation: '', style: 'col-lg-6', backName: 'userName' },
                      { label: 'الرقم السري', type: 'text', validation: '', style: 'col-lg-6', backName: 'password' },
                      { label: 'اسم المرسل', type: 'text', validation: '', style: 'col-lg-6', backName: 'senderName' },

                    ]}
                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/emailBody'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`نصوص رسائل البريد`}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: 'تعديل نصوص البريد', path: '/Ar/TAW/Main/emailBody' }
                    ]}
                    pageName='emailBody'
                    read={{
                      url: ip + '/api/GetEmailSubject',
                      verb: 'GET'
                    }}
                    type="generalSettings"
                    action={{
                      url: ip + '/api/UpdateEmailSubject',
                      body: {
                        "id": '',
                        "permissionsSubject": "",
                        "lateSubject": "",
                        "absentSubject": "",
                        "vocationSubject": ""
                      },
                      verb: 'POST'
                    }}
                    EntityProps={[

                      {
                        label: 'الأذونات', type: 'textarea',
                        items: [{ label: 'الاسم', value: '{{EMPLOYEE_NAME}}' },
                        { label: 'التاريخ', value: ' {{DATE}}' }], rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'permissionsSubject', noFormCont: true,
                      },
                      {
                        label: 'التأخير', type: 'textarea', items: [{ label: 'الاسم', value: '{{EMPLOYEE_NAME}}' },
                        { label: 'التاريخ', value: ' {{DATE}}' },
                        { label: 'التاخير', value: ' {{LATE}}' }], rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'lateSubject', noFormCont: true,
                      },
                      {
                        label: 'الغياب', type: 'textarea', items: [{ label: 'الاسم', value: '{{EMPLOYEE_NAME}}' },
                        { label: 'التاريخ', value: ' {{DATE}}' }], rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'absentSubject', noFormCont: true,
                      },
                      {
                        label: 'الأجازات', type: 'textarea', items: [{ label: 'الاسم', value: '{{EMPLOYEE_NAME}}' },
                        { label: 'التاريخ', value: ' {{DATE}}' }], rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'vocationSubject', noFormCont: true,
                      },

                    ]}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/smsBody'
            render={
              function ({ match }) {
                return (
                  <ModalPageAr
                    title={`نصوص الرسائل  `}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: 'تعديل نصوص الرسائل', path: '/Ar/TAW/Main/smsBody' }
                    ]}
                    pageName='smsBody'
                    read={{
                      url: ip + '/api/GetSMSSubject',
                      verb: 'GET'
                    }}
                    type="generalSettings"
                    action={{
                      url: ip + '/api/UpdateSMSSubject',
                      body: {
                        "id": '',
                        "permissionsSubject": "",
                        "lateSubject": "",
                        "absentSubject": "",
                        "vocationSubject": ""
                      },
                      verb: 'POST'
                    }}
                    EntityProps={[

                      { label: 'الأذونات', type: 'textarea', rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'permissionsSubject', noFormCont: true, },
                      { label: 'التأخير', type: 'textarea', rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'lateSubject', noFormCont: true, },
                      { label: 'الغياب', type: 'textarea', rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'absentSubject', noFormCont: true, },
                      { label: 'الأجازات', type: 'textarea', rows: "4", class: "form-control", validation: '', style: 'col-lg-12 my-2', backName: 'vocationSubject', noFormCont: true, },

                    ]}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/messagesSettings'
            render={
              function ({ }) {
                return (
                  <MessagesSettings
                    mainTitle={`الاعدادات الخاصة بتفعيل الرسائل`}
                    title={'الاعدادات الخاصة بتفعيل الرسائل'}
                    path={[
                      { title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                    ]}
                    params={[]}
                    columns={[
                      { name: '', backName: '', selection: true },
                      { name: 'الاعداد ', backName: ' ' },
                      { name: 'رسائل', backName: 'isAlertLateWithEmail', checkbox: true },
                      { name: 'رسائل ايميل', backName: 'isAlertLateWithSMS', checkbox: true },
                      { name: 'تحديد الموظفين ', backName: ' ' },
                    ]}
                    createEntityProps={[]}
                    updateEntityProps={[
                      { label: 'Read', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'isAlertLateWithEmail' },
                      { label: 'Add', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'isAlertLateWithSMS' },
                    ]}

                    deleteMessage='هل تريد حذف هذا العنصر؟'

                    read={{
                      url: ip + '/api/GetGeneralMessageSetting',
                      verb: 'GET'
                    }}

                    update={{
                      url: ip + '/api/UpdateGeneralMessageSetting',
                      body: {
                        "id": 0,
                        "isBlock": true,
                        "isLateTime": true,
                        "alertLateTime": "00:00",
                        "isAlertLateWithEmail": true,
                        "isAlertLateWithSMS": true,
                        "isAlertForManagerLateWithEmail": true,
                        "isAlertForManagerLateWithSMS": true,
                        "lateEmployees": [],
                        "isAlertAbsentWithEmail": true,
                        "isAlertAbsentWithSMS": true,
                        "isAlertForManagerAbsentWithEmail": true,
                        "isAlertForManagerAbsentWithSMS": true,
                        "absentEmployees": [],
                        "isAlertVocationWithEmail": true,
                        "isAlertVocationWithSMS": true,
                        "isAlertForManagerVocationWithEmail": true,
                        "isAlertForManagerVocationWithSMS": true,
                        "vocationEmployees": [],
                        "isAlertPermissionWithEmail": true,
                        "isAlertpermissionWithSMS": true,
                        "isAlertForManagerPermissionWithEmail": true,
                        "isAlertForManagerPermissionWithSMS": true,
                        "permissionEmployees": []
                      },
                      verb: 'POST'
                    }}

                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 41) : null}
                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/Settings/Employees/:id'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={match.params.id == 1 ? 'تنبيه التاخير ' : match.params.id == 2 ? 'تنبيه الغياب' : match.params.id == 3 ? 'تنبيه الاذونات'
                      : 'تنبيه الاجازات '}
                    title={match.params.id == 1 ? 'تنبيه التاخير ' : match.params.id == 2 ? 'تنبيه الغياب' : match.params.id == 3 ? 'تنبيه الاذونات'
                      : 'تنبيه الاجازات '}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'الاعدادات العامة ', path: '/Ar/TAW/Main/GeneralSettings' },
                      { title: 'تفعيل  الرسائل', path: '/Ar/TAW/Main/messagesSettings' },
                    ]}
                    searchFields={[
                      {
                        label: 'الكود', type: 'text', backName: 'employeeCode'
                      },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: API.Directorates.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: API.Departments.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: API.Shifts.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    modalSearchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: ip + '/api/Branches/GetAllBranchsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: ip + '/api/Directorate/GetAllDirectorateDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    columns={[
                      {
                        name: 'الكود', backName: 'employeeCode'
                      },
                      { name: 'الإسم', backName: 'nameAr' },
                      { name: 'الفرع', backName: 'branchName' },
                      { name: 'الدوام', backName: 'shiftName' }
                    ]}
                    createEntityProps={[]}
                    useSearchModal={true}
                    noEdit={true}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    //to get the modal data for search modal
                    modalRead={{
                      url: ip + '/api/GetLateEmployeesNotfoundGeneralSettingMessages',
                      body: {
                        "pageSize": 0,
                        "pageNumber": 0,
                        "type": match.params.id,
                        "search": {
                          "employeeCode": 0,
                          "nameAr": "",
                          "branchId": 0,
                          "adminstratId": 0,
                          "departmentId": 0,
                          "shiftId": 0
                        }
                      },
                      verb: 'POST'
                    }}
                    //the back
                    modalBackName={
                      match.params.id == 1 ? 'lateEmployees' : match.params.id == 2 ? 'absentEmployees' : match.params.id == 3 ? 'permissionEmployees'
                        : 'vocationEmployees'}
                    create={{
                      url: ip + "/api/AddGeneralSettingMessagesEmployees",
                      body: {
                        "type": match.params.id,
                        "lateEmployees": [],
                        "absentEmployees": [],
                        "vocationEmployees": [],
                        "permissionEmployees": []
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + "/api/GetEmployeesGeneralSettingMessages",
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "type": match.params.id,
                        "search": {
                          "employeeCode": 0,
                          "nameAr": "",
                          "branchId": 0,
                          "adminstratId": 0,
                          "departmentId": 0,
                          "shiftId": 0
                        }
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: ip + "/api/AddGeneralSettingMessagesEmployees",
                      body: {
                        "type": match.params.id,
                        "lateEmployees": [],
                        "absentEmployees": [],
                        "vocationEmployees": [],
                        "permissionEmployees": []
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: ip + "/api/RemoveGeneralSettingMessagesEmployees",
                      body: {
                        "id": []
                      }, verb: 'POST'
                    }}
                    addType={match.params.id}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 8) : null}

                  />
                )
              }
            }
          />




          <Route exact={true} path='/Ar/TAW/Main/EmployeesGroups'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={EmployeesGroups.mainTitle}
                    title={EmployeesGroups.title}
                    path={EmployeesGroups.path}
                    searchFields={EmployeesGroups.searchFields}
                    columns={EmployeesGroups.columns}
                    createEntityProps={EmployeesGroups.createEntityProps}
                    updateEntityProps={EmployeesGroups.updateEntityProps}
                    deleteMessage={EmployeesGroups.deleteMessage}
                    create={EmployeesGroups.create}
                    read={EmployeesGroups.read}
                    update={EmployeesGroups.update}
                    delete={EmployeesGroups.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 8) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/EmployeesGroups/Employees/:id/:name'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={match.params.name}
                    title={match.params.name}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'مجموعات الموظفين', path: '/Ar/TAW/Main/EmployeesGroups' }
                    ]}
                    searchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: API.Directorates.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: API.Departments.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }

                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: API.Shifts.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    modalSearchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: ip + '/api/Branches/GetAllBranchsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: ip + '/api/Directorate/GetAllDirectorateDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    columns={[
                      { name: 'الكود', backName: 'employeeCode' },
                      { name: 'الإسم', backName: 'nameAr' },
                      { name: 'الفرع', backName: 'branchName' },
                      { name: 'الدوام', backName: 'shiftName' }
                    ]}
                    createEntityProps={[]}
                    useSearchModal={true}
                    noEdit={true}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    //to get the modal data for search modal
                    modalRead={{
                      url: ip + '/api/EmployeeGroupsDetails/SearchEmployeeForGroups',
                      body: {
                        "pageSize": 100,
                        "pageNumber": 0,
                        "search": {
                          "employeeCode": 0,
                          "nameEn": "",
                          "nameAr": "",
                          "branchId": 0,
                          "departmentId": 0,
                          "adminstratId": 0,
                          "jobId": 0,
                          "groupId": null,
                          "shiftId": 0
                        }
                      },
                      verb: 'POST'
                    }}
                    //the back
                    modalBackName='employeeId'
                    create={{
                      url: API.EmployeeGroupsDetails.create,
                      body: {
                        "employeeGroupsId": Number.parseInt(match.params.id),
                        "employeeId": []
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: API.EmployeeGroupsDetails.read,
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "search": {
                          "employeeCode": 0,
                          "nameEn": "",
                          "nameAr": "",
                          "branchId": 0,
                          "departmentId": 0,
                          "adminstratId": 0,
                          "jobId": 0,
                          "groupId": Number.parseInt(match.params.id),
                          "shiftId": 0
                        }
                        // EmployeeGroupId: match.params.id
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: API.EmployeeGroupsDetails.update,
                      body: {
                        "employeeId": [
                          0
                        ]
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: API.EmployeeGroupsDetails.delete,
                      body: {
                        "employeeId": []
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 8) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/VacationsTypes'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={VacationsTypes.mainTitle}
                    title={VacationsTypes.title}
                    path={VacationsTypes.path}
                    searchFields={VacationsTypes.searchFields}
                    columns={VacationsTypes.columns}
                    createEntityProps={VacationsTypes.createEntityProps}
                    updateEntityProps={VacationsTypes.updateEntityProps}
                    deleteMessage={VacationsTypes.deleteMessage}
                    create={VacationsTypes.create}
                    read={VacationsTypes.read}
                    update={VacationsTypes.update}
                    delete={VacationsTypes.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 9) : null}

                  />
                )
              }
            }
          />
          <Route exact={true} path='/Ar/TAW/Main/OfficialHolidays'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={OfficialHolidays.mainTitle}
                    title={OfficialHolidays.title}
                    path={OfficialHolidays.path}
                    searchFields={OfficialHolidays.searchFields}
                    columns={OfficialHolidays.columns}
                    createEntityProps={OfficialHolidays.createEntityProps}
                    updateEntityProps={OfficialHolidays.updateEntityProps}
                    deleteMessage={OfficialHolidays.deleteMessage}
                    create={OfficialHolidays.create}
                    read={OfficialHolidays.read}
                    update={OfficialHolidays.update}
                    delete={OfficialHolidays.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 10) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/OfficialHolidays/:id/:name'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={`موظفون العطلة ${match.params.name}`}
                    title={match.params.name}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'العطلات الرسمية', path: '/Ar/TAW/Main/OfficialHolidays' }
                    ]}
                    searchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'إسم الموظف', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: API.Directorates.dropdown,
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    modalSearchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: ip + '/api/Branches/GetAllBranchsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: ip + '/api/Directorate/GetAllDirectorateDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    columns={[
                      { name: 'الكود', backName: 'employeeCode' },
                      { name: 'إسم الموظف', backName: 'nameAr' },
                      { name: 'الفرع', backName: 'branchName' },
                      { name: 'الدوام', backName: 'shiftName' }
                    ]}
                    createEntityProps={[]}
                    useSearchModal={true}
                    noEdit={true}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    modalRead={{
                      url: ip + '/api/OfficialVacationDetails/SearchEmployeeNotInOfficialVacation',
                      body: {
                        "pageSize": 100,
                        "pageNumber": 0,
                        "search": {
                          "officialVacationId": Number.parseInt(match.params.id)
                        }
                      },
                      verb: 'POST'
                    }}
                    modalBackName='employeeId'
                    create={{
                      url: ip + '/api/OfficialVacationDetails/AddEmployeeOfficialVacation',
                      body: {
                        "employeeId": [],
                        "officialVacationId": Number.parseInt(match.params.id),
                        "isavailable": true
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + '/api/OfficialVacationDetails/SearchEmployeeInOfficialVacation',
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "search": {
                          "officialVacationId": Number.parseInt(match.params.id)
                        }
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: '',
                      body: {},
                      verb: 'POST'
                    }}
                    delete={{
                      url: ip + '/api/OfficialVacationDetails/DeleteEmployeeOfficialVacationDetails',
                      body: {
                        "employeeId": [],
                        "officialVacationId": Number.parseInt(match.params.id),
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 10) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/UnregisteredEmployees'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle='موظفون غير مسجلين'
                    title='موظفون غير مسجلين'
                    path={[{ title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }]}
                    searchFields={[
                      { label: 'الكود', type: 'number', backName: 'employeeCode' }
                    ]}
                    columns={[
                      {
                        name: 'الكود',
                        backName: 'employeeCode'
                      },
                      {
                        name: 'الإسم',
                        backName: 'employeeName'
                      }
                    ]}
                    createEntityProps={Employees.createEntityProps}
                    updateEntityProps={Employees.updateEntityProps}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    create={Employees.createUnrigestered}
                    read={{
                      url: ip + '/api/Transaction/ReadMachineTransactionsEmployeesNotFound',
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "search": {
                          "from": '',
                          "to": '',
                          "branchIds": [
                          ],
                          "employeeCode": ''
                        }
                      },
                      verb: 'POST'
                    }}
                    update={Employees.createUnrigestered}
                    delete={{
                      url: ip + '/api/Transaction/RemoveMachineTransactionForEmployeesNotFound',
                      query: {
                        machineTransactionId: ''
                      },
                      verb: 'POST'
                    }}
                    noCreate={true}
                    routUnregistered={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 1)?.data.find(page => page.id === 11) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/GetBranchTransactions'
            render={
              function () {
                return (
                  <ProcedurePageAr
                    mainTitle={GetBranchTransactions.mainTitle}
                    title={GetBranchTransactions.title}
                    path={GetBranchTransactions.path}
                    columns={GetBranchTransactions.columns}
                    actionEntityProps={GetBranchTransactions.actionEntityProps}
                    action={GetBranchTransactions.action}
                    btnTxt='سحب حركات الفروع'
                    btnClr='#55ce63'
                    actionSearch={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 12) : null}
                  />
                )
              }
            }
          />
          {/* <Route path='/Ar/TAW/Main/cancel'
            render={
              function () {
                return (
                  <DashBoard>
                    API Not Found
                  </DashBoard>
                )
              }
            }
          /> */}
          <Route path='/Ar/TAW/Main/DisplayTransactions'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle='عرض الحركات'
                    title='عرض الحركات'
                    path={[{ title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }]}
                    searchFields={
                      [
                        { label: 'كود الموظف', type: 'text', backName: 'employeeCode' },
                        { label: 'إسم الموظف', type: 'text', backName: 'employeeName' },
                        {
                          label: 'الفرع', type: 'select', backName: 'branchId', url: API.Branches.dropdown,
                          body: {
                            "pageSize": 100,
                            "pageNumber": 0,
                            "searchCriteria": "",
                            "selectedId": [
                              0
                            ]
                          },
                          item: { value: 'id', label: 'nameAr' }
                        },
                        {
                          label: 'الإدارة', type: 'select', backName: 'administrationId', url: API.Directorates.dropdown,
                          body: {
                            "pageSize": 100,
                            "pageNumber": 0,
                            "searchCriteria": "",
                            "selectedId": [
                              0
                            ]
                          },
                          item: { value: 'id', label: 'nameAr' }
                        },
                        {
                          label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                          body: {
                            "pageSize": 100,
                            "pageNumber": 0,
                            "searchCriteria": "",
                            "selectedId": [
                              0
                            ]
                          },
                          item: { value: 'id', label: 'nameAr' }
                        },
                        {
                          label: 'الوظيفة', type: 'select', backName: 'jobId', url: API.Jobs.dropdown,
                          body: {
                            "pageSize": 100,
                            "pageNumber": 0,
                            "searchCriteria": "",
                            "selectedId": [
                              0
                            ]
                          },
                          item: { value: 'id', label: 'nameAr' }
                        },
                        {
                          label: 'المجموعة', type: 'select', backName: 'groupId', url: ip + '/api/EmployeeGroups/GetAllEmployeeGroupsDropDown',
                          body: {
                            "pageSize": 100,
                            "pageNumber": 0,
                            "searchCriteria": "",
                            "selectedId": [
                              0
                            ]
                          },
                          item: { value: 'id', label: 'nameAr' }
                        },
                        {
                          label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                          body: {
                            "pageSize": 100,
                            "pageNumber": 0,
                            "searchCriteria": "",
                            "selectedId": [
                              0
                            ]
                          },
                          item: { value: 'id', label: 'nameAr' }
                        },
                        { label: 'التاريخ', type: 'date', backName: 'date', backSearch: true }
                      ]
                    }
                    columns={[
                      { name: 'كود الموظف', backName: 'employeeCode' },
                      { name: 'إسم الموظف', backName: 'employeeName' },
                      { name: 'الفرع', backName: 'branchName' },
                      { name: 'الدوام', backName: 'shiftName' },
                      { name: 'وقت الحضور', backName: 'timeIn' },
                      { name: 'وقت الانصراف', backName: 'timeOut' },
                      { name: 'معدل يدويا', backName: 'manual', boolean: true },
                      { name: 'مرحّل', backName: 'isMoved', boolean: true }
                    ]}
                    read={{
                      url: ip + '/api/MovedTransaction/GetAllTransactions',
                      body: {
                        "search": {
                          "date": new Date().toJSON().slice(0, 10),
                          "branchIds": [],
                          "employeeIds": [],
                          "employeeName": ""
                        }
                      },
                      verb: 'POST'
                    }
                    }
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 14) : null}
                    print={false}
                    excel={false}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AddPermission'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={AddPermission.mainTitle}
                    title={AddPermission.title}
                    path={AddPermission.path}
                    searchFields={AddPermission.searchFields}
                    columns={AddPermission.columns}
                    createEntityProps={AddPermission.createEntityProps}
                    updateEntityProps={AddPermission.updateEntityProps}
                    deleteMessage={AddPermission.deleteMessage}
                    create={AddPermission.create}
                    read={AddPermission.read}
                    update={AddPermission.update}
                    delete={AddPermission.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 17) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AddVacation'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={AddVacation.mainTitle}
                    title={AddVacation.title}
                    path={AddVacation.path}
                    searchFields={AddVacation.searchFields}
                    columns={AddVacation.columns}
                    createEntityProps={AddVacation.createEntityProps}
                    updateEntityProps={AddVacation.updateEntityProps}
                    deleteMessage={AddVacation.deleteMessage}
                    create={AddVacation.create}
                    read={AddVacation.read}
                    update={AddVacation.update}
                    delete={AddVacation.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 18) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/TransferTransactions'
            render={
              function () {
                return (
                  <ProcedurePageAr
                    title='ترحيل الحركات'
                    mainTitle='ترحيل الحركات'
                    path={[{ title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }]}
                    columns={[
                      {
                        name: 'الحركات الغير مرحلة',
                        backName: 'count'
                      }]}
                    modalSearchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: ip + '/api/Branches/GetAllBranchsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: ip + '/api/Directorate/GetAllDirectorateDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    modalRead={{
                      url: ip + '/api/Employee/SearchAllEmployees',
                      body: {
                        "pageSize": 1000,
                        "pageNumber": 0,
                        "search": {
                          "employeeCode": "",
                          "nameEn": "",
                          "nameAr": "",
                          "phoneNumber": "",
                          "placeStay": "",
                          "email": "",
                          "branchId": 0,
                          "departmentId": 0,
                          "adminstratId": 0,
                          "jobId": 0,
                          "projectId": 0,
                          "shiftId": 0,
                          "nationalitiesId": 0
                        }
                      },
                      verb: 'POST'
                    }}
                    modalBackName='employeeIds'
                    actionEntityProps={[
                      // ['Not Transferred Trans.:', 'readOnly', '', '', ''],
                      { label: 'من', type: 'date', validation: '', style: '', backName: 'from' },
                      { label: 'إلى', type: 'date', validation: '', style: '', backName: 'to' },
                      { label: 'الموظفون', type: 'searchModal', validation: '', style: '', backName: 'employeeIds' }
                    ]}
                    action={{
                      url: ip + '/api/MovedTransaction/MovedTransaction',
                      body: {
                        "employeeIds": [],
                        "from": "",
                        "to": ""
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + '/api/MovedTransaction/GetMachineTransactions',
                      body: {
                        "search": {
                          "from": "",
                          "to": "",
                          "branchIds": [],
                          "employeeIds": [],
                          "employeeName": ""
                        }
                      },
                      verb: 'POST'
                    }}
                    btnTxt='ترحيل الحركات'
                    btnClr='#55ce63'
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 13) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/CancelTransferTransactions'
            render={
              function () {
                return (
                  <ProcedurePageAr
                    title='إلغاء ترحيل الحركات'
                    mainTitle='إلغاء ترحيل الحركات'
                    path={[{ title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }]}
                    columns={[]}
                    modalSearchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: ip + '/api/Branches/GetAllBranchsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: ip + '/api/Directorate/GetAllDirectorateDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    modalRead={{
                      url: ip + '/api/Employee/SearchAllEmployees',
                      body: {
                        "pageSize": 1000,
                        "pageNumber": 0,
                        "search": {
                          "employeeCode": "",
                          "nameEn": "",
                          "nameAr": "",
                          "phoneNumber": "",
                          "placeStay": "",
                          "email": "",
                          "branchId": 0,
                          "departmentId": 0,
                          "adminstratId": 0,
                          "jobId": 0,
                          "projectId": 0,
                          "shiftId": 0,
                          "nationalitiesId": 0
                        }
                      },
                      verb: 'POST'
                    }}
                    modalBackName='employeeIds'
                    actionEntityProps={[
                      { label: 'من', type: 'date', validation: 'Required', style: '', backName: 'from' },
                      { label: 'إلى', type: 'date', validation: 'Required', style: '', backName: 'to' },
                      { label: 'الموظفون', type: 'searchModal', validation: '', style: '', backName: 'employeeIds' }
                    ]}
                    action={{
                      url: ip + '/api/MovedTransaction/RemoveMovedTransaction',
                      body: {
                        "employeeIds": [],
                        "from": "",
                        "to": ""
                      },
                      verb: 'POST'
                    }}
                    btnTxt='إلغاء ترحيل الحركات'
                    btnClr='#F44336'
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 15) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AddEditTransactions'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={AddEditTransactions.mainTitle}
                    title={AddEditTransactions.title}
                    removeModalTitleName={true}
                    path={AddEditTransactions.path}
                    searchFields={AddEditTransactions.searchFields}
                    columns={AddEditTransactions.columns}
                    createEntityProps={AddEditTransactions.createEntityProps}
                    updateEntityProps={AddEditTransactions.updateEntityProps}
                    deleteMessage={AddEditTransactions.deleteMessage}
                    create={AddEditTransactions.create}
                    read={AddEditTransactions.read}
                    update={AddEditTransactions.update}
                    delete={AddEditTransactions.delete}
                    showEmpty={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 16) : null}
                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/CancelManuallyTrans'
            render={
              function () {
                return (
                  <ProcedurePageAr
                    title='إلغاء الحركات المعدلة يدوياً'
                    mainTitle='إلغاء الحركات المعدلة يدوياً'
                    path={[{ title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }]}
                    columns={[]}
                    modalSearchFields={[
                      { label: 'الكود', type: 'text', backName: 'employeeCode' },
                      { label: 'الإسم', type: 'text', backName: 'nameAr' },
                      {
                        label: 'الفرع', type: 'select', backName: 'branchId', url: ip + '/api/Branches/GetAllBranchsDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الإدارة', type: 'select', backName: 'adminstratId', url: ip + '/api/Directorate/GetAllDirectorateDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'القسم', type: 'select', backName: 'departmentId', url: ip + '/api/Department/GetAllDepartmentDropDown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      },
                      {
                        label: 'الدوام', type: 'select', backName: 'shiftId', url: ip + '/api/Shift/GetAllShiftDropdown',
                        body: {
                          "pageSize": 100,
                          "pageNumber": 0,
                          "searchCriteria": "",
                          "selectedId": [
                            0
                          ]
                        },
                        item: { value: 'id', label: 'nameAr' }
                      }
                    ]}
                    modalRead={{
                      url: ip + '/api/Employee/SearchAllEmployees',
                      body: {
                        "pageSize": 1000,
                        "pageNumber": 0,
                        "search": {
                          "employeeCode": "",
                          "nameEn": "",
                          "nameAr": "",
                          "phoneNumber": "",
                          "placeStay": "",
                          "email": "",
                          "branchId": 0,
                          "departmentId": 0,
                          "adminstratId": 0,
                          "jobId": 0,
                          "projectId": 0,
                          "shiftId": 0,
                          "nationalitiesId": 0
                        }
                      },
                      verb: 'POST'
                    }}
                    modalBackName='employeeIds'
                    actionEntityProps={[
                      { label: 'من', type: 'date', validation: '', style: '', backName: 'from' },
                      { label: 'إلى', type: 'date', validation: '', style: '', backName: 'to' },
                      { label: 'الموظفون', type: 'searchModal', validation: '', style: '', backName: 'employeeIds' }
                    ]}
                    action={{
                      url: ip + '/api/MovedTransaction/RemoveAddAndEditedTransaction',
                      body: {
                        "employeeIds": [],
                        "from": "",
                        "to": ""
                      },
                      verb: 'POST'
                    }}
                    btnTxt='إلغاء الحركات المعدلة يدوياً'
                    btnClr='#F44336'
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 2)?.data.find(page => page.id === 15) : null}
                  />
                )
              }
            }
          />
          {/* <Route path='/Ar/TAW/Main/DeleteEmployeesData'
            render={
              function () {
                return (
                  <DashBoard>
                    API Not Found
                  </DashBoard>
                )
              }
            }
          /> */}

          <Route path='/Ar/TAW/Main/EmployeesReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={EmployeesReport.mainTitle}
                    title={EmployeesReport.title}
                    path={EmployeesReport.path}
                    searchFields={EmployeesReport.searchFields}
                    preTableFields={EmployeesReport.preTableFields}
                    singleTable={true}
                    columns={EmployeesReport.columns}
                    read={EmployeesReport.read}
                    print={EmployeesReport.print}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 19) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/WorkingTimeReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={WorkingTimeReport.mainTitle}
                    title={WorkingTimeReport.title}
                    path={WorkingTimeReport.path}
                    searchFields={WorkingTimeReport.searchFields}
                    preTableFields={WorkingTimeReport.preTableFields}
                    columns={WorkingTimeReport.columns}
                    totals={WorkingTimeReport.totals}
                    read={WorkingTimeReport.read}
                    print={WorkingTimeReport.print}
                    period={true}
                    WorkingTime={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 20) : null}

                  />

                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/DayStatusReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={DayStatusReport.mainTitle}
                    title={DayStatusReport.title}
                    path={DayStatusReport.path}
                    searchFields={DayStatusReport.searchFields}
                    preTableFields={DayStatusReport.preTableFields}
                    columns={DayStatusReport.columns}
                    totals={DayStatusReport.totals}
                    read={DayStatusReport.read}
                    print={DayStatusReport.print}
                    period={DayStatusReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 21) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main '
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={DayStatusReport.mainTitle}
                    title={DayStatusReport.title}
                    path={DayStatusReport.path}
                    searchFields={DayStatusReport.searchFields}
                    preTableFields={DayStatusReport.preTableFields}
                    columns={DayStatusReport.columns}
                    totals={DayStatusReport.totals}
                    read={DayStatusReport.read}
                    print={DayStatusReport.print}
                    period={DayStatusReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 21) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/DetailedAttendanceReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={DetailedAttendanceReport.mainTitle}
                    title={DetailedAttendanceReport.title}
                    path={DetailedAttendanceReport.path}
                    searchFields={DetailedAttendanceReport.searchFields}
                    preTableFields={DetailedAttendanceReport.preTableFields}
                    columns={DetailedAttendanceReport.columns}
                    totals={DetailedAttendanceReport.totals}
                    read={DetailedAttendanceReport.read}
                    print={DetailedAttendanceReport.print}
                    period={DetailedAttendanceReport.period}
                    excel={true}
                    DetailedReport={true}
                    printPeriod={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 22) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/TotalAttendanceReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={TotalAttendanceReport.mainTitle}
                    title={TotalAttendanceReport.title}
                    path={TotalAttendanceReport.path}
                    searchFields={TotalAttendanceReport.searchFields}
                    preTableFields={TotalAttendanceReport.preTableFields}
                    columns={TotalAttendanceReport.columns}
                    totals={TotalAttendanceReport.totals}
                    read={TotalAttendanceReport.read}
                    print={TotalAttendanceReport.print}
                    period={DetailedAttendanceReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 23) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AbsenceReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={AbsenceReport.mainTitle}
                    title={AbsenceReport.title}
                    path={AbsenceReport.path}
                    searchFields={AbsenceReport.searchFields}
                    columns={AbsenceReport.columns}
                    totals={AbsenceReport.totals}
                    read={AbsenceReport.read}
                    print={AbsenceReport.print}
                    period={AbsenceReport.period}
                    singleTable={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 24) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/DelayReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={DelayReport.mainTitle}
                    title={DelayReport.title}
                    path={DelayReport.path}
                    searchFields={DelayReport.searchFields}
                    preTableFields={DelayReport.preTableFields}
                    columns={DelayReport.columns}
                    totals={DelayReport.totals}
                    read={DelayReport.read}
                    print={DelayReport.print}
                    period={DelayReport.period}
                    singleTable={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 25) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/InCompleteTransReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={InCompleteTransReport.mainTitle}
                    title={InCompleteTransReport.title}
                    path={InCompleteTransReport.path}
                    searchFields={InCompleteTransReport.searchFields}
                    preTableFields={InCompleteTransReport.preTableFields}
                    columns={InCompleteTransReport.columns}
                    totals={InCompleteTransReport.totals}
                    read={InCompleteTransReport.read}
                    print={InCompleteTransReport.print}
                    period={InCompleteTransReport.period}
                    printPeriod={false}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 26) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/EarlyAttendanceReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={EarlyAttendanceReport.mainTitle}
                    title={EarlyAttendanceReport.title}
                    path={EarlyAttendanceReport.path}
                    searchFields={EarlyAttendanceReport.searchFields}
                    preTableFields={EarlyAttendanceReport.preTableFields}
                    columns={EarlyAttendanceReport.columns}
                    totals={EarlyAttendanceReport.totals}
                    read={EarlyAttendanceReport.read}
                    print={EarlyAttendanceReport.print}
                    period={InCompleteTransReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 27) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/AttendanceSummaryReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={AttendanceSummaryReport.mainTitle}
                    title={AttendanceSummaryReport.title}
                    path={AttendanceSummaryReport.path}
                    searchFields={AttendanceSummaryReport.searchFields}
                    preTableFields={AttendanceSummaryReport.preTableFields}
                    columns={AttendanceSummaryReport.columns}
                    totals={AttendanceSummaryReport.totals}
                    read={AttendanceSummaryReport.read}
                    print={AttendanceSummaryReport.print}
                    period={AttendanceSummaryReport.period}
                    colored={true}
                    singleTable={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 28) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/TotalAttendanceSummaryReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={TotalAttendanceSummaryReport.mainTitle}
                    title={TotalAttendanceSummaryReport.title}
                    path={TotalAttendanceSummaryReport.path}
                    searchFields={TotalAttendanceSummaryReport.searchFields}
                    preTableFields={TotalAttendanceSummaryReport.preTableFields}
                    columns={TotalAttendanceSummaryReport.columns}
                    totals={TotalAttendanceSummaryReport.totals}
                    read={TotalAttendanceSummaryReport.read}
                    print={TotalAttendanceSummaryReport.print}
                    period={TotalAttendanceSummaryReport.period}
                    printPeriod={true}
                    excel={true}
                    DetailedReport={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 29) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/OvertimeReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={OvertimeReport.mainTitle}
                    title={OvertimeReport.title}
                    path={OvertimeReport.path}
                    searchFields={OvertimeReport.searchFields}
                    preTableFields={OvertimeReport.preTableFields}
                    columns={OvertimeReport.columns}
                    totals={OvertimeReport.totals}
                    read={OvertimeReport.read}
                    print={OvertimeReport.print}
                    period={OvertimeReport.period}
                    printPeriod={true}
                    overtime={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 29) : null}

                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/WorkingTimeDetailsReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={WorkingTimeDetailsReport.mainTitle}
                    title={WorkingTimeDetailsReport.title}
                    path={WorkingTimeDetailsReport.path}
                    searchFields={WorkingTimeDetailsReport.searchFields}
                    preTableFields={WorkingTimeDetailsReport.preTableFields}
                    columns={WorkingTimeDetailsReport.columns}
                    totals={WorkingTimeDetailsReport.totals}
                    read={WorkingTimeDetailsReport.read}
                    print={WorkingTimeDetailsReport.print}
                    period={WorkingTimeDetailsReport.period}
                    printPeriod={true}
                    workingTimeDetails={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 31) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/BranchAttendanceReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={BranchAttendanceReport.mainTitle}
                    title={BranchAttendanceReport.title}
                    path={BranchAttendanceReport.path}
                    searchFields={BranchAttendanceReport.searchFields}
                    preTableFields={BranchAttendanceReport.preTableFields}
                    columns={BranchAttendanceReport.columns}
                    totals={BranchAttendanceReport.totals}
                    read={BranchAttendanceReport.read}
                    print={BranchAttendanceReport.print}
                    period={BranchAttendanceReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 32) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/VacationsReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={VacationsReport.mainTitle}
                    title={VacationsReport.title}
                    path={VacationsReport.path}
                    searchFields={VacationsReport.searchFields}
                    preTableFields={VacationsReport.preTableFields}
                    columns={VacationsReport.columns}
                    totals={VacationsReport.totals}
                    read={VacationsReport.read}
                    print={VacationsReport.print}
                    period={VacationsReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 33) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/PermissionsReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={PermissionsReport.mainTitle}
                    title={PermissionsReport.title}
                    path={PermissionsReport.path}
                    searchFields={PermissionsReport.searchFields}
                    preTableFields={PermissionsReport.preTableFields}
                    columns={PermissionsReport.columns}
                    totals={PermissionsReport.totals}
                    read={PermissionsReport.read}
                    print={PermissionsReport.print}
                    period={PermissionsReport.period}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 34) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/DelayEarlyReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={DelayEarlyReport.mainTitle}
                    title={DelayEarlyReport.title}
                    path={DelayEarlyReport.path}
                    searchFields={DelayEarlyReport.searchFields}
                    preTableFields={DelayEarlyReport.preTableFields}
                    columns={DelayEarlyReport.columns}
                    totals={DelayEarlyReport.totals}
                    read={DelayEarlyReport.read}
                    print={DelayEarlyReport.print}
                    singleTable={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 35) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/TotalAbsenceReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={TotalAbsenceReport.mainTitle}
                    title={TotalAbsenceReport.title}
                    path={TotalAbsenceReport.path}
                    searchFields={TotalAbsenceReport.searchFields}
                    preTableFields={TotalAbsenceReport.preTableFields}
                    columns={TotalAbsenceReport.columns}
                    totals={TotalAbsenceReport.totals}
                    read={TotalAbsenceReport.read}
                    print={TotalAbsenceReport.print}
                    period={TotalAbsenceReport.period}
                    printPeriod={true}
                    abcentFrom={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 36) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/TotalDelayReport'
            render={
              function () {
                return (
                  <ReportPageAr
                    mainTitle={TotalDelayReport.mainTitle}
                    title={TotalDelayReport.title}
                    path={TotalDelayReport.path}
                    searchFields={TotalDelayReport.searchFields}
                    preTableFields={TotalDelayReport.preTableFields}
                    columns={TotalDelayReport.columns}
                    totals={TotalDelayReport.totals}
                    read={TotalDelayReport.read}
                    print={TotalDelayReport.print}
                    period={TotalDelayReport.period}
                    delay={true}
                    excel={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 3)?.data.find(page => page.id === 37) : null}
                  />
                )
              }
            }
          />

















          <Route path='/Ar/TAW/Main/Devices'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={Devices.mainTitle}
                    title={Devices.title}
                    path={Devices.path}
                    searchFields={Devices.searchFields}
                    columns={Devices.columns}
                    createEntityProps={Devices.createEntityProps}
                    updateEntityProps={Devices.updateEntityProps}
                    deleteMessage={Devices.deleteMessage}
                    create={Devices.create}
                    read={Devices.read}
                    update={Devices.update}
                    delete={Devices.delete}
                    devices={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 38) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/SpecialWorkingDays'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={SpecialWorkingDays.mainTitle}
                    title={SpecialWorkingDays.title}
                    path={SpecialWorkingDays.path}
                    searchFields={SpecialWorkingDays.searchFields}
                    columns={SpecialWorkingDays.columns}
                    createEntityProps={SpecialWorkingDays.createEntityProps}
                    updateEntityProps={SpecialWorkingDays.updateEntityProps}
                    deleteMessage={SpecialWorkingDays.deleteMessage}
                    create={SpecialWorkingDays.create}
                    read={SpecialWorkingDays.read}
                    update={SpecialWorkingDays.update}
                    delete={SpecialWorkingDays.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 39) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/UserPermission' exact={true}
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={UserPermission.mainTitle}
                    title={UserPermission.title}
                    path={UserPermission.path}
                    searchFields={UserPermission.searchFields}
                    columns={UserPermission.columns}
                    createEntityProps={UserPermission.createEntityProps}
                    updateEntityProps={UserPermission.updateEntityProps}
                    deleteMessage={UserPermission.deleteMessage}
                    create={UserPermission.create}
                    read={UserPermission.read}
                    update={UserPermission.update}
                    delete={UserPermission.delete}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 40) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/UserPermission/Permissions/:groupId/:groupName'
            render={
              function ({ match }) {
                return (
                  <PermissionsPageAr
                    mainTitle={`الصلاحيات في (${match.params.groupName})`}
                    title={match.params.groupName}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'صلاحيات المستخدمين', path: '/Ar/TAW/Main/UserPermission' }
                    ]}
                    params={match.params}
                    columns={[
                      { name: '', backName: '', selection: true },
                      // { name: 'الرقم', backName: 'id' },
                      { name: 'اسم الصفحة', backName: 'nameAr' },
                      { name: 'عرض', backName: 'Get', checkbox: true },
                      { name: 'إضافة', backName: 'Add', checkbox: true },
                      { name: 'تعديل', backName: 'Edite ', checkbox: true },
                      { name: 'حذف', backName: 'Delete', checkbox: true },
                      { name: 'طباعة', backName: 'Print', checkbox: true },

                    ]}
                    createEntityProps={[]}
                    updateEntityProps={[
                      { label: 'Read', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'active' },
                      { label: 'Add', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'active' },
                      { label: 'Edit', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'active' },
                      { label: 'Delete', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'active' },
                      { label: 'Print', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-6', backName: 'active' },
                    ]}

                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    create={{
                      url: API.Directorates.create,
                      body: {
                        nameAr: '',
                        nameEn: '',
                        branchId: match.params.groupId,
                        managerId: ''
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + '/api/CustomGroupPermission/GetAllPagesPermission',
                      body: {
                        "pageSize": 100,
                        "pageNumber": 0,
                        "searchCriteria": "",
                        "selectedId": [
                          0
                        ]
                      },
                      query: {
                        groupId: match.params.groupId
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: ip + '/api/AddGroupPermissions',
                      body: {
                        "groupId": match.params.groupId,
                        "pagePermissions": [
                          // {
                          //   "pageId": 0,
                          //   "permissionIds": [
                          //   ]
                          // }
                        ]
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: API.Directorates.delete,
                      query: {
                        branchId: ''
                      },
                      verb: 'POST'
                    }}
                    noCreate={true}
                    noDelete={true}
                    noEdit={true}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 40) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/UserPermission/Users/:groupId/:groupName'
            render={
              function ({ match }) {
                return (
                  <BasicPageAr
                    mainTitle={`المستخدمين في (${match.params.groupName})`}
                    title={match.params.groupName}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' },
                      { title: 'صلاحيات المستخدمين', path: '/Ar/TAW/Main/UserPermission' }
                    ]}
                    columns={[
                      { name: 'الكود', backName: 'userCode' },
                      { name: 'الإسم', backName: 'name' },
                      { name: 'اسم المستخدم', backName: 'userName' }
                    ]}
                    modalColumns={[
                      { name: 'الكود', backName: 'userCode' },
                      { name: 'الإسم', backName: 'name' },
                      { name: 'اسم المستخدم', backName: 'userName' }
                    ]}
                    createEntityProps={[]}
                    useSearchModal={true}
                    noEdit={true}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    modalRead={{
                      url: ip + '/api/GetAllCompaniesUsersNotInGroup',
                      body: {
                        "pageSize": 100,
                        "pageNumber": 0,
                        "searchCriteria": "",
                        "selectedId": [
                          0
                        ]
                      },
                      verb: 'POST'
                    }}
                    modalBackName='userIds'
                    create={{
                      url: ip + '/api/CustomGroupPermission/AddCustomUserGroup',
                      body: {
                        "groupId": match.params.groupId,
                        "userIds": []
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + '/api/CustomGroupPermission/GetUsersForGroups',
                      body: {
                        "groupId": [match.params.groupId],
                        "pageSize": 10,
                        "pageNumber": 0,
                        "searchCriteria": "",
                        "selectedId": [
                          0
                        ]
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: API.EmployeeGroupsDetails.update,
                      body: {
                        "employeeId": [
                          0
                        ]
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: ip + '/api/CustomGroupPermission/RemoveCustomUserGroup',
                      body: {
                        "userIds": [],
                        "groupId": match.params.groupId
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 40) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/UsersAccounts'
            render={
              function () {
                return (
                  <BasicPageAr
                    mainTitle={'حسابات المستخدمين'}
                    title={'حسابات المستخدمين'}
                    path={[
                      { title: 'الرئيسية', path: '/Ar/TAW/Main/Dashboard' }
                    ]}
                    // searchFields={[]}
                    columns={[
                      { name: 'الكود', backName: 'userCode' },
                      { name: 'الإسم', backName: 'name' },
                      { name: 'اسم المستخدم', backName: 'userName' }
                    ]}
                    createEntityProps={[
                      { label: 'اسم المستخدم', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'userName' },
                      { label: 'كلمة المرور', type: 'password', validation: 'Required', style: 'col-lg-6', backName: 'password' },
                      { label: 'البريد الإلكتروني', type: 'email', validation: 'Required', style: 'col-lg-6', backName: 'email' },
                      { label: 'الإسم', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'name' },
                      // { label: 'I Agree to Privacy Policy', type: 'checkbox', validation: '', style: '', backName: 'isOk' },
                    ]}
                    updateEntityProps={[
                      { label: 'اسم المستخدم', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'userName' },
                      { label: 'كلمة المرور', type: 'password', validation: 'Required', style: 'col-lg-6', backName: 'password' },
                      { label: 'البريد الإلكتروني', type: 'email', validation: 'Required', style: 'col-lg-6', backName: 'email' },
                      { label: 'الإسم', type: 'text', validation: 'Required', style: 'col-lg-6', backName: 'name' },
                      // { label: 'I Agree to Privacy Policy', type: 'checkbox', validation: '', style: '', backName: 'isOk' },
                    ]}
                    deleteMessage='هل تريد حذف هذا العنصر؟'
                    create={{
                      url: ip + '/api/RegisterUsersForCompany',
                      body: {
                        "userName": "",
                        "email": "",
                        "password": "",
                        "name": "",
                        "isOk": true
                      },
                      verb: 'POST'
                    }}
                    read={{
                      url: ip + '/api/GetAllCompaniesUsers',
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "searchCriteria": "",
                        "selectedId": []
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: ip + '/api/UpdateUserAccount',
                      body: {
                        "id": "",
                        "userName": "",
                        "email": "",
                        "password": "",
                        "name": "",
                        "isOk": true
                      },
                      verb: 'POST'
                    }}
                    delete={{
                      url: ip + '/api/RemoveUserAccount',
                      query: {
                        userId: ''
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 43) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/CompanyInfo'
            render={
              function () {
                return (
                  <CompanyInfoAr
                    updateEntityProps={[
                      { label: 'اسم الشركة العربي', type: 'text', validation: '', style: 'col-lg-6', backName: 'companyNameAr' },
                      { label: 'اسم الشركة الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'companyNameEn' },
                      { label: 'النشاط العربي', type: 'text', validation: '', style: 'col-lg-6', backName: 'companyActivityAr' },
                      { label: 'النشاط الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'companyActivityEn' },
                      { label: 'العنوان العربي', type: 'text', validation: '', style: 'col-lg-6', backName: 'adressAr' },
                      { label: 'العنوان الإنجليزي', type: 'text', validation: '', style: 'col-lg-6', backName: 'adressEn' },
                      { label: 'الهاتف', type: 'text', validation: '', style: 'col-lg-6', backName: 'companyPhoneNumber' },
                      { label: 'الفاكس', type: 'text', validation: '', style: 'col-lg-6', backName: 'fax' },
                      { label: 'الموقع الإلكتروني', type: 'text', validation: '', style: 'col-lg-6', backName: 'website' },
                      { label: 'البريد الإلكتروني', type: 'email', validation: '', style: 'col-lg-6', backName: 'email' },
                    ]}
                    read={{
                      url: ip + '/api/GetUserData',
                      verb: 'GET'
                    }}
                    update={{
                      url: ip + '/api/UpdatUser',
                      body: {
                        model: {
                          "id": "",
                          "email": "",
                          "companyNameAr": "",
                          "companyNameEn": "",
                          "adressAr": "",
                          "adressEn": "",
                          "companyActivityAr": "",
                          "companyActivityEn": "",
                          "fax": "",
                          "website": "",
                          "companyPhoneNumber": ""
                        },
                        imagePath: ''
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 42) : null}
                  />
                )
              }
            }
          />
          <Route path='/Ar/TAW/Main/GeneralSettings'
            render={
              function () {
                return (
                  <FormPageAr
                    title={`الإعدادات العامة`}
                    updateEntityProps={[
                      { label: 'وقت إهمال تكرار البصمة من الموظف بالدقائق', type: 'number', validation: '', noFormCont: true , style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left ', backName: 'timeToNeglectRepeatFingerPrint' },
                      {
                        label: 'عدد الورديات التي تظهر في التقرير', type: 'staticSelect', validation: '',  noFormCont: true ,style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left ', backName: 'numberOfSeqanceWhichWillShow',


                        items: [
                          { label: 'وردية', value: 1 },
                          { label: 'ورديتان', value: 2 },
                          { label: 'ثلاث ورديات', value: 3 },
                          { label: 'أربع ورديات', value: 4 }
                        ]
                      },
                      { label: 'يحتسب الإضافي قبل الدوام بالدقائق', type: 'number', validation: '', noFormCont: true , style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: 'extraTimeBeforeShift' },
                      { label: 'يحتسب الإضافي بعد الدوام بالدقائق', type: 'number', validation: '', noFormCont: true, style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: 'extraTimeAfterShift' },
                      { label: ['يتم احتساب اليوم غياب بعد تأخير', 'بالدقائق'], type: 'shiftEndNextDay', noFormCont: true, dropdownAlign: ' border-left', validation: '', style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: ['isTimeAbsenceAfterDelay', 'timeAbsenceAfterDelay'], inputType: 'number' },
                      { label: ['يتم احتساب اليوم غياب بعد انصراف مبكر', 'بالدقائق'], type: 'shiftEndNextDay', noFormCont: true, dropdownAlign: ' border-left', validation: '', style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: ['isTimeAbsenceAfterEarlyLeave', 'timeAbsenceAfterEarlyLeave'], inputType: 'number' },
                      { label: 'احتساب أول حركة دخول و آخر حركة انصراف', type: 'checkbox', noFormCont: true, validation: '', style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: 'isFirstMoveAttendAndLastMoveLeave' },
                      { label: 'إعدادات السحب التلقائي', type: 'link', validation: '', to: '/Ar/TAW/Main/autoTransaction', noFormCont: true, name: 'تغيير البيانات', style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: '' },
                      // { label: 'إعدادات الباقة', type: 'link', validation: '', to: '/Ar/TAW/Main/planEdites', name: 'تغيير البيانات', style: 'col-lg-11 mb-5 border h-auto', titleSize: 'col-sm-5 border-left mt-0 ', backName: '' },

                      { label: 'إعدادات الباقة', type: 'link', validation: '', to: '/Ar/TAW/Main/planEdites', name: 'تغيير البيانات', noFormCont: true, style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: '' },
                      { label: 'إعدادات البريد', type: 'link', validation: '', to: '/Ar/TAW/Main/emailEdites', name: 'تغيير البيانات', noFormCont: true, style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: '' },
                      { label: 'إعدادات الرسائل ', type: 'link', validation: '', to: '/Ar/TAW/Main/smsEdites', name: 'تغيير البيانات', noFormCont: true, style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: '' },
                      { label: 'ادخال نصوص البريد', type: 'link', validation: '', to: '/Ar/TAW/Main/emailBody', name: 'تغيير البيانات', noFormCont: true, style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: '' },
                      { label: 'ادخال نصوص الرسائل', type: 'link', validation: '', to: '/Ar/TAW/Main/smsBody', name: 'تغيير البيانات', noFormCont: true, style: 'col-lg-11 mb-0 border border-bottom-0', titleSize: 'col-sm-5 border-left', backName: '' },
                      { label: 'الاعدادات الخاصة بتفعيل الرسائل', type: 'link', validation: '', to: '/Ar/TAW/Main/messagesSettings', name: 'تغيير البيانات', noFormCont: true, style: 'col-lg-11 mb-5 border h-auto', titleSize: 'col-sm-5 border-left mt-0 ', backName: '' },


                      { label: 'إعدادات تقرير  الألوان', type: 'header', validation: '', style: 'col-lg-12', titleSize: 'col-12', backName: '' },
                      { label: ' الأذن', type: 'color', validation: '', style: '', titleSize: '', backName: 'perimmisionColor' },
                      { label: 'الغياب', type: 'color', validation: '', style: '', titleSize: '', backName: 'absentColor' },
                      { label: 'عطلة اسبوعية', type: 'color', validation: '', style: '', titleSize: '', backName: 'weekEndColor' },
                      { label: 'مداوم', type: 'color', validation: '', style: '', titleSize: '', backName: 'workColor' },
                      { label: 'أجازة', type: 'color', validation: '', style: '', titleSize: '', backName: 'vacationColor' },
                      { label: 'تأخير', type: 'color', validation: '', style: '', titleSize: '', backName: 'lateColor' },
                      { label: 'انصراف مبكر', type: 'color', validation: '', style: '', titleSize: '', backName: 'earlyLeaveColor' },
                      { label: 'عطلة رسمية', type: 'color', validation: '', style: '', titleSize: '', backName: 'officialVacationColor' },


                    ]}
                    read={{
                      url: ip + '/api/GeneralSetting/GetGeneralSettings',
                      body: {
                        "pageSize": 10,
                        "pageNumber": 0,
                        "searchCriteria": "",
                        "selectedId": [
                          0
                        ]
                      },
                      verb: 'POST'
                    }}
                    update={{
                      url: ip + '/api/GeneralSetting/AddGeneralSetting',
                      body: {
                        "id": 0,
                        "timeToNeglectRepeatFingerPrint": 0,
                        "numberOfSeqanceWhichWillShow": 0,
                        "extraTimeBeforeShift": 0,
                        "extraTimeAfterShift": 0,
                        "timeAbsenceAfterDelay": 0,
                        "timeAbsenceAfterEarlyLeave": 0,
                        "isFirstMoveAttendAndLastMoveLeave": false,
                        "isTimeAbsenceAfterDelay": false,
                        "isTimeAbsenceAfterEarlyLeave": false,
                        "perimmisionColor": "",
                        "absentColor": "",
                        "weekEndColor": "",
                        "workColor": "",
                        "vacationColor": "",
                        "lateColor": "",
                        "earlyLeaveColor": "",
                        "officialVacationColor": ""
                      },
                      verb: 'POST'
                    }}
                    permissions={mainLayout.state.loadedPermissions ? mainLayout.state.permissions.find(tab => tab.id === 4)?.data.find(page => page.id === 41) : null}
                  />
                )
              }
            }
          />

          <Route path='/Ar/TAW/Main/ChangePassword'
            render={
              function () {
                return (
                  <ModalPageAr
                    title={`تغيير كلمة المرور`}
                    path={[{ title: 'الرئيسية ', path: '/Ar/TAW/Main/Dashboard' }, { title: 'تغيير كلمة المرور ', path: '/Ar/TAW/Main/ChangePassword' }]}
                    EntityProps={[
                      { label: 'كلمة المرور الحالية', type: 'password', validation: 'Required', style: 'col-lg-12', backName: 'oldPassword' },
                      { label: 'كلمة المرور الجديدة', type: 'password', validation: 'Required', style: 'col-lg-12', backName: 'newPassword' },
                      { label: 'تأكيد كلمة المرور', type: 'password', validation: 'Required Compare', style: 'col-lg-12', backName: 'confirmPassword' }]}
                    read={undefined}
                    action={{
                      url: ip + '/api/ChangePassword',
                      body: {
                        "companyName": Cookie.get('companyName'),
                        "userName": Cookie.get('userName'),
                        "oldPassword": "",
                        "newPassword": "",
                        "confirmPassword": ""
                      },
                      verb: 'POST'
                    }}
                    routOut={true}
                  />
                )
              }
            }
          />

          {/* if there is no token redirect to write company name */}
          {!Cookie.get('token') ? <Redirect to="/" /> : null}
        </section>
      </div>
    );
  }
}


function upLayer() {
  const mainLayout = document.querySelector("#mainLayout");
  mainLayout.classList.remove("down-layer");
}

function downLayer() {
  const mainLayout = document.querySelector("#mainLayout");
  mainLayout.classList.add("down-layer");
}


export default MainLayoutAr;
export { upLayer, downLayer }